import createBaseService from "@/api/base-service.ts";
import type { Profile } from "../../types/profile";

const profileService = {
	...createBaseService<Profile>("/public-profile"),
};

export default profileService;
